<template>
    <div>
        <ServerError v-if="ServerError" />
        <PageLoader :storage="appLoading" />
        <v-snackbar v-model="showSnackBar" :color="appColor" right :timeout="timeout">
            <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">
                    <span style="color: #fff">{{ msg }}</span>
                </v-flex>
                <v-flex text-right>
                    <v-btn small :ripple="false" text @click="showSnackBar = false">
                        <v-icon style="color: #fff">mdi-close</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-snackbar>
        <v-layout wrap justify-start pt-3 pl-2 pr-5>
            <v-flex align-self-center xs12 text-left>
                <span class="itemHeading1">Fencing List</span>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
            <v-flex xs12 pt-4>
                <v-card v-if="projectdata && projectdata.length > 0">
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left itemform tableheadingclass">Name</th>
                                    <th class="text-left itemform tableheadingclass">Type</th>
                                    <th class="text-left itemform tableheadingclass">Entry On</th>
                                    <th class="text-left itemform tableheadingclass">Added By</th>
                                    <th class="text-left itemform tableheadingclass">Status</th>
                                    <th class="text-center itemform tableheadingclass">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in projectdata" :key="index">
                                    <td class="itemform">{{ item.name }}</td>
                                    <td class="itemform text-capitalize">{{ item.type }}</td>
                                    <td class="itemform">{{ formatDate(item.entryOn) }}</td>
                                    <td class="itemform">{{ item.addedby.name }}</td>
                                    <td class="itemform">
                                        <v-chip small :color="item.status === 'active' ? 'success' : 'grey'"
                                            text-color="white" class="text-capitalize">
                                            {{ item.status }}
                                        </v-chip>
                                    </td>
                                    <td class="text-center">
                                        <v-btn tile small depressed outlined :color="appColor" :ripple="false"
                                            @click="viewItem(item)" class="itemValue">
                                            <span :style="{ color: appColor }"> View </span>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
                <v-card v-else-if="!appLoading" class="pa-5 text-center">
                    <span class="itemform">No Fencing Data Found!</span>
                </v-card>
            </v-flex>
            <v-flex xs12 pb-4 v-if="projectdata && projectdata.length > 0">
                <v-layout wrap justify-center pt-4>
                    <v-flex xs10>
                        <v-pagination v-model="currentPage" :length="Pagelength" :total-visible="7" circle
                            :color="appColor" small></v-pagination>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            appLoading: false,
            ServerError: false,
            showSnackBar: false,
            timeout: 3000,
            msg: null,
            projectdata: [],
            currentPage: 1,
            Pagelength: 0,
            count: 20,
        };
    },
    watch: {
        currentPage() {
            this.getData();
        },
    },
    beforeMount() {
        this.getData();
    },
    methods: {
        getData() {
            this.appLoading = true;
            axios({
                method: "GET",
                url: "/fencing/list",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                params: {
                    limit: this.count,
                    page: this.currentPage,
                },
            })
                .then((response) => {
                    if (response.data.status == true) {
                        this.projectdata = response.data.data;
                        this.Pagelength = response.data.total
                            ? Math.ceil(response.data.total / this.count)
                            : 1;
                        this.appLoading = false;
                    } else {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                        this.appLoading = false;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                });
        },
        formatDate(dateString) {
            if (!dateString) return "-";
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
        },
        viewItem(item) {
            if (item && item._id) {
                this.$router.push({
                    path: "/Admin/fencing-view",
                    query: { id: item._id },
                });
            }
        },
    },
};
</script>

<style scoped>
.itemHeading1 {
    font-family: poppinssemibold;
    font-size: 24px;
    color: #000;
}

.itemform {
    font-family: poppinsmedium;
    font-size: 14px;
}

.tableheadingclass {
    background-color: #f8f9fa;
    color: #000 !important;
    font-family: poppinssemibold;
}

.itemValue {
    font-family: poppinsmedium;
    text-transform: none;
}
</style>
